import zhLocale from 'element-ui/lib/locale/lang/zh-CN'  // 饿了么

import { bloomTestZh } from './bloom-test'               // bloom-test
import { loginOrResZh } from './loginOrRes'
import { homeZh } from './home/'
import { headerZh } from './header/'
import { authenticationZh } from './authentication/'
import { battleZh } from './battle/'
import { proctorZh } from './proctor/proctor'
import { mobileZh } from './proctor/mobile'
import { faceTipBoxZh } from './proctor/faceTipBox'
import { sqZh } from './sq'
import { waitingExaminationZh } from './proctor/waitingExamination'
import { equipmentCheckZh } from './proctor/equipmentCheck'
import { automaticResponseZh } from './proctor/automaticResponse'
import { flowHomeZH } from './flow/home'
import { flowAcademicReportZH } from './flow/academicReport'
import { flowActiveZH } from './flow/active'
import { flowAdmissionTicketZH } from './flow/admissionTicket'
import { flowCertificateZH } from './flow/certificate'
import { flowComplainZH } from './flow/complain'
import { flowConsultZH } from './flow/consult'
import { flowCouponZH } from './flow/coupon'
import { flowDiscoverZH } from './flow/discover'
import { flowFollowUsZH } from './flow/followUs'
import { flowGradeReportZH } from './flow/gradeReport'
import { flowGroupZH } from './flow/group'
import { flowLoginZH } from './flow/login'
import { flowMessageZH } from './flow/message'
import { flowOrderZH } from './flow/order'
import { flowPayTheFeesZH } from './flow/payTheFees'
import { flowPersonalDataZH } from './flow/personalData'
import { flowReviewZH } from './flow/review'
import { flowSignUpZH } from './flow/signUp'
import { flowTaskZH } from './flow/task'
import { flowTeamUpZH } from './flow/teamUp'
import { flowImageZH } from './flow/image'

const zh = {
  ...flowImageZH,
  ...flowAcademicReportZH,
  ...flowGroupZH,
  ...flowTeamUpZH,
  ...flowTaskZH,
  ...flowSignUpZH,
  ...flowPersonalDataZH,
  ...flowReviewZH,
  ...flowPayTheFeesZH,
  ...flowMessageZH,
  ...flowOrderZH,
  ...flowLoginZH,
  ...flowGradeReportZH,
  ...flowFollowUsZH,
  ...flowDiscoverZH,
  ...flowCouponZH,
  ...flowConsultZH,
  ...flowComplainZH,
  ...flowAdmissionTicketZH,
  ...flowCertificateZH,
  ...flowActiveZH,
  ...bloomTestZh,
  ...loginOrResZh,
  ...homeZh,
  ...headerZh,
  ...zhLocale,
  ...authenticationZh,
  ...battleZh,
  ...proctorZh,
  ...mobileZh,
  ...faceTipBoxZh,
  ...sqZh,
  ...waitingExaminationZh,
  ...equipmentCheckZh,
  ...automaticResponseZh,
  ...flowHomeZH
}
export default zh



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js